import { Box } from "@mui/material";
import React from "react";
// import { drawerWidth } from "store/constant";
import AuthFooter from "ui-component/cards/AuthFooter";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                bgcolor: "white",
                borderRadius: "5px",
                width: `100%`,
                height: "50px",
                p: 2,
            }}>
            <AuthFooter />
        </Box>
    )
}

export default Footer;